module.exports = __webpack_public_path__ + "img/D201511_1.959dce52.jpg";